import { Component, OnDestroy, OnInit } from '@angular/core';
import { ShoppingCartFacade, PurchaseFacade, SwishState, SwishFacade } from '@ridango/components';
import { Observable, Subject } from 'rxjs';
import { clearCartState } from '@ridango/components/lib/localStorage';
import { NgRedux } from '@angular-redux/store';
import { takeUntil } from 'rxjs/operators';

@Component({
    templateUrl: './swish-confirmation-page.component.html'
})
export class SwishConfirmationPageComponent implements OnInit, OnDestroy {
    private componentDestroyed$ = new Subject<void>();
    showNavigationModal = false;
    navigateAwaySelection$: Subject<boolean> = new Subject<boolean>();
    shoppingCartService: any;

    status = '';
    swishTransactionStatus$: Observable<any> = this.swishFacade.transactionStatus$;

    constructor(
        private cartFacade: ShoppingCartFacade,
        private purchaseFacade: PurchaseFacade,
        private swishFacade: SwishFacade,
        private ngRedux: NgRedux<SwishState>
    ) {}

    ngOnInit() {
        this.swishTransactionStatus$.pipe(takeUntil(this.componentDestroyed$)).subscribe((s) => {
            if (s) {
                this.status = s;
            }
        });
    }

    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }

    onCloseNavigationModal() {
        this.showNavigationModal = false;
        this.navigateAwaySelection$.next(false);
    }

    onConfirmNavigationModal() {
        this.cartFacade.deleteCart();
        this.purchaseFacade.unsetShoppingCart();
        this.navigateAwaySelection$.next(true);
        clearCartState();
        this.showNavigationModal = false;
    }

    canDeactivate() {
        this.showNavigationModal = true;
        if (this.status !== 'PENDING') {
            return true;
        }
        return this.navigateAwaySelection$;
    }
}
